import axios from 'axios';

export const FETCH_OPINIONS = 'FETCH_OPINIONS';
export const FETCH_OPINION_TYPES = 'FETCH_OPINION_TYPES';
export const FETCH_OPINION_JURISDICTIONS = 'FETCH_OPINION_JURISDICTIONS';
export const SELECTED_TYPE = 'SELECTED_TYPE';
export const SELECTED_JURISDICTION = 'SELECTED_JURISDICTION';
export const SELECTED_STATUS = 'SELECTED_STATUS';
export const SEARCH_TERM = 'SEARCH_TERM';
export const PAGE_NUMBER = 'PAGE_NUMBER';
export const PER_PAGE = 'PER_PAGE';
export const TOTAL_PAGES = 'TOTAL_PAGES';
export const TOTAL_RESULTS = 'TOTAL_RESULTS';
export const COMMISSIONED_OPINIONS = 'COMMISSIONED_OPINIONS';
export const TOTAL_PUBLISHED = 'TOTAL_PUBLISHED';
export const LOADING = 'LOADING';

// For debouncing search and canceling previous requests
let debounceTimer = null;
let currentRequest = null;

export function fetchOpinions() {
	return ( dispatch, getState ) => {
		dispatch( { type: LOADING, payload: true } );
		const {
			      selectedType,
			      pagination,
			      selectedJurisdiction,
			      selectedStatus,
			      searchTerm
		      } = getState();
		let params = '';

		if ( parseInt( selectedType ) ) {
			params += `&opinion_type=${ selectedType }`;
		}

		if ( parseInt( selectedJurisdiction ) ) {
			params += `&opinion_jurisdiction=${ selectedJurisdiction }`;
		}

		if ( '' !== selectedStatus ) {
			params += `&opinion_status=${ selectedStatus }`;
		}

		const url = `${ wpApiSettings.root }${ wp.api.versionString }opinion?_embed${ params }&orderby=title&order=asc&per_page=${ pagination.perPage }&page=${ pagination.pageNum }&search=${ searchTerm }`;

		// Cancel any previous request
		if ( currentRequest ) {
			currentRequest.cancel( 'Operation canceled due to new request.' );
		}

		// Create a new CancelToken
		const cancelToken = axios.CancelToken;
		const source = cancelToken.source();
		currentRequest = source;

		axios.get( url, { cancelToken: source.token } )
		     .then( response => {
			     currentRequest = null;
			     dispatch( {
				               type: FETCH_OPINIONS, payload: response.data
			               } );
			     dispatch( {
				               type   : TOTAL_PAGES,
				               payload: response.headers[ 'x-wp-totalpages' ]
			               } );
			     dispatch( {
				               type   : TOTAL_RESULTS,
				               payload: response.headers[ 'x-wp-total' ]
			               } );
			     dispatch( {
				               type   : COMMISSIONED_OPINIONS,
				               payload: response.headers[ 'x-commissioned-opinions' ]
			               } );
			     dispatch( {
				               type   : TOTAL_PUBLISHED,
				               payload: response.headers[ 'x-total-published-opinions' ]
			               } );
		     } )
		     .catch( error => {
			     if ( axios.isCancel( error ) ) {
				     console.log( 'Request canceled:', error.message );
			     } else {
				     console.error( 'Error fetching opinions:', error );
			     }
		     } )
		     .finally( () => {
			     dispatch( { type: LOADING, payload: false } );
		     } );
	};
}

export function fetchOpinionTerms( term ) {
	return ( dispatch ) => {
		const url = `${wpApiSettings.root}${wp.api.versionString}${term}?per_page=99`;
		axios.get( url ).then( response => {
			switch ( term ) {
				case 'opinion_type':
					dispatch( {
						          type   : FETCH_OPINION_TYPES,
						          payload: response.data
					          } );
					break;
				case 'opinion_jurisdiction':
					dispatch( {
						          type   : FETCH_OPINION_JURISDICTIONS,
						          payload: response.data
					          } );
					break;
			}
		} );
	};
}

export function searchOpinions( searchTerm = '' ) {
	return ( dispatch ) => {
		'use strict';

		// Immediately update the search term for UI
		dispatch( {
			          type: SEARCH_TERM, payload: searchTerm
		          } );

		// Clear any existing timer
		if ( debounceTimer ) {
			clearTimeout( debounceTimer );
		}

		// Set a new timer for .75 second
		debounceTimer = setTimeout( () => {
			// After delay, trigger the fetch
			dispatch( fetchOpinions() );
		}, 750 );
	};
}

export function changeOpinionType( id ) {
	return ( dispatch ) => {
		dispatch( {
			          type: SELECTED_TYPE, payload: id
		          } );
	};
}

export function changeJurisdiction( id ) {
	return ( dispatch ) => {
		dispatch( {
			          type: SELECTED_JURISDICTION, payload: id
		          } );
	};
}

export function changeStatus( id ) {
	return ( dispatch ) => {
		dispatch( {
			          type: SELECTED_STATUS, payload: id
		          } );
	};
}

export function setPage( pageNum ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: PAGE_NUMBER, payload: pageNum
		          } );
	};
}

export function changePageCount( newCount ) {
	return (
		dispatch => {
			dispatch( {
				          type: PER_PAGE, payload: newCount
			          } );
		}
	);
}

export function changeSearchTerm( searchTerm ) {
	return (
		dispatch => {
			dispatch( {
				          type: SEARCH_TERM, payload: searchTerm
			          } );
		}
	);
}
